import { render, staticRenderFns } from "./Platform.vue?vue&type=template&id=68e008c8&scoped=true&"
import script from "./Platform.vue?vue&type=script&lang=js&"
export * from "./Platform.vue?vue&type=script&lang=js&"
import style0 from "./Platform.vue?vue&type=style&index=0&id=68e008c8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "68e008c8",
  null
  
)

export default component.exports